import { Component, h, Host, Prop, State, Watch } from "@stencil/core";
import { SpinnerOverlayStatusEnum, SpinnerOverlayTransitionStatusType } from "./spinner-overlay-status";
import {LoaderVariant} from "../loader/loader.enum";


@Component({
    tag: "ux-spinner-overlay",
    styleUrl: "spinner-overlay.scss",
    shadow: false
})
export class SpinnerOverlay {
    /** Boolean to indicate if or not the spinner-overlay is currently opened */
    @Prop({ reflect: true }) readonly opened: boolean = false;

    /** The spinner-overlay transition status */
    @State() status: SpinnerOverlayTransitionStatusType = SpinnerOverlayStatusEnum.CLOSED;

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    private transitionTimeout: any | null = null;

    @Watch("opened")
    setOverlayStatus() {
        if (this.transitionTimeout !== null) {
            clearTimeout(this.transitionTimeout);
        }
        if (this.opened) {
            if (this.status === SpinnerOverlayStatusEnum.OPENED) {
                return;
            }
            this.status = SpinnerOverlayStatusEnum.OPENING;
            this.transitionTimeout = setTimeout(() => {
                this.status = SpinnerOverlayStatusEnum.OPENED;
            }, 100);
        } else {
            if (this.status === SpinnerOverlayStatusEnum.CLOSED) {
                return;
            }
            this.status = SpinnerOverlayStatusEnum.CLOSING;
            this.transitionTimeout = setTimeout(() => {
                this.status = SpinnerOverlayStatusEnum.CLOSED;
            }, 350);
        }
    }

    componentWillLoad() {
        this.setOverlayStatus();
    }

    render() {
        const renderSpinner = this.status !== SpinnerOverlayStatusEnum.CLOSED;
        return (
            <Host
                class={{
                    ["ux-spinner-overlay"]: true,
                    [`ux-spinner-overlay--${this.status}`]: true
                }}
            >
                <div class='ux-spinner-overlay__backdrop'>
                    {renderSpinner && <ux-loader variant={LoaderVariant.Spinner}></ux-loader>}
                </div>
            </Host>
        );
    }
}
